import { render, staticRenderFns } from "./PopupDuplicateFile.vue?vue&type=template&id=30b3edd2&scoped=true&"
import script from "./PopupDuplicateFile.vue?vue&type=script&lang=js&"
export * from "./PopupDuplicateFile.vue?vue&type=script&lang=js&"
import style0 from "./PopupDuplicateFile.vue?vue&type=style&index=0&id=30b3edd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3edd2",
  null
  
)

export default component.exports